import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
// import { LocalNotifications } from '@ionic-native/local-notifications';
import * as moment from 'moment';
import { EstatusRetosEquipo } from '@domain/estatus.reto.equipo';
import { EstatusRetoEnum } from '@domain/estatus.reto.enum';
import { App } from "ionic-angular";
import { HomeTCPage } from '@pages';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class LocalNotificationProvider {

  constructor(
      // private localNotifications: LocalNotifications,
      private platform: Platform,
      private translateService: TranslateService,
      private app: App
    ) {
    this.platform.ready()
    .then( _ => {
      if(!this.platform.is('cordova')) {
        return;
      }
      // this.localNotifications.on('click')
      //  .subscribe(
      //    (notification) => {
      //      this.app.getRootNavs()[0].setRoot(HomeTCPage);
      //    }
      //  );
    })

  }

  createNotificationTeamChallenge(estatus: EstatusRetosEquipo) {

    if(!this.platform.is('cordova')) {
      return;
    }

    if(estatus.estatus === EstatusRetoEnum.PROXIMO_INICIAR || estatus.estatus === EstatusRetoEnum.ESPERAR_RONDA) {
      let now = moment(new Date());
      let notification = now.clone().add(estatus.counterback, 'minutes');

      let notificationBefore = notification.clone().subtract(10, 'minutes');

      let schedule = {
        id: 1,
        title: this.translateService.instant('localNotificacion.schedule.title'),
        text: this.translateService.instant('localNotificacion.schedule.text'),
        trigger: {at: new Date(notification.format())},
        data: { secret: notification.format() }
      };

      let scheduleBefore = {
        id: 2,
        title: this.translateService.instant('localNotificacion.scheduleBefore.title'),
        text: this.translateService.instant('localNotificacion.scheduleBefore.text'),
        trigger: {at: new Date(notificationBefore.format())},
        data: { secret: notificationBefore.format() }
      };

      // this.localNotifications.isScheduled(1)
      //   .then( estatus => {
      //     if(estatus) {
      //       this.localNotifications.update(schedule);
      //     } else {
      //       this.localNotifications.schedule(schedule);
      //     }
      //   });

      // this.localNotifications.isScheduled(2)
      //   .then( estatus => {
      //     if(estatus) {
      //       this.localNotifications.update(scheduleBefore);
      //     } else {
      //       this.localNotifications.schedule(scheduleBefore);
      //     }
      //   });
    } else {
      // this.localNotifications.cancel(1);
      // this.localNotifications.cancel(2);
    }

  }

}



// WEBPACK FOOTER //
// ./src/providers/local-notification/local-notification.ts